import {Outlet} from 'react-router';
import {useAppNavigate} from '../lib/use-app-navigate';
import Sidebar from "../components/Private/Sidebar";
import React, {useEffect} from "react";
import {useUser} from "../Providers/UserInfo";
import {Spinner} from "@heroui/react";
import NotificationProvider from "../Providers/Notification";
import {MobileNavProvider} from "../components/Private/MobileNavProvider";

const PrivateLayout = () => {
    const {is_open, loading, sessionActive, error} = useUser();
    const nav = useAppNavigate();
    const showActivationBanner = !loading && is_open === false;

    useEffect(() => {
        if (!sessionActive || error) {
            nav('/login', {replace: true});
        }
    }, [sessionActive, error, nav]);

    if (!sessionActive || error) {
        return (
            <div className="center min-h-screen w-full">
                <Spinner color="warning"/>
            </div>
        );
    }

    if (loading) {
        return <div className="center min-h-[60vh] w-full"><Spinner color="warning"/></div>;
    }

    return (
        <NotificationProvider>
            <MobileNavProvider>
                <div className="rest-panel">
                    <div className="rest-panel__layout">
                        <Sidebar/>
                        <main className="rest-panel__main">
                            {showActivationBanner && (
                                <div
                                    className="rest-menu-save-feedback rest-menu-save-feedback--warning"
                                    role="alert"
                                >
                                    فعال‌سازی رستوران خاموش است. در صورت تمایل از سایدبار آن را روشن کنید.
                                </div>
                            )}
                            <Outlet/>
                        </main>
                    </div>
                </div>
            </MobileNavProvider>
        </NotificationProvider>
    );
};

export default PrivateLayout;
